import type { StoreScheduleModel } from '@schema/cart';

const DAYS_LIST = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const transformScheduleToStoreInfoSchedule = (
  schedule: Array<{
    days: string;
    hours: string;
    status?: string | null;
  }>
): StoreScheduleModel[] => {
  if (!schedule) return [];

  const result: StoreScheduleModel[] = [];

  schedule.forEach(i => {
    const status = i.status || 'work';
    const hours = i.hours?.trim() || '';
    const daysStr = i.days?.trim() || '';
    const dayAbbreviations: string[] = [];

    if (daysStr.includes(',')) {
      dayAbbreviations.push(...daysStr.split(',').map(d => d.trim()));
    } else if (daysStr.includes('-')) {
      const [startDay, endDay] = daysStr.split('-').map(d => d.trim());
      const startIndex = DAYS_LIST.indexOf(startDay);
      const endIndex = DAYS_LIST.indexOf(endDay);

      if (startIndex >= 0 && endIndex >= 0 && startIndex <= endIndex) {
        for (let idx = startIndex; idx <= endIndex; idx++) {
          dayAbbreviations.push(DAYS_LIST[idx]);
        }
      } else {
        dayAbbreviations.push(daysStr);
      }
    } else {
      dayAbbreviations.push(daysStr);
    }

    dayAbbreviations.forEach(dayAbbr => {
      const dayIndex = DAYS_LIST.indexOf(dayAbbr);

      if (dayIndex < 0) {
        return;
      }

      const dayNumber = dayIndex + 1;

      if (status === 'close') {
        result.push({
          day: dayNumber,
          start_time: null,
          end_time: null,
          max_time: null,
          status: 'close'
        });
        return;
      }

      if (!hours?.includes('-')) {
        result.push({
          day: dayNumber,
          start_time: null,
          end_time: null,
          max_time: null,
          status: 'work'
        });
        return;
      }

      const timeParts = hours.split('-');
      const startTimeStr = timeParts[0].trim().split(':')[0];
      const endTimeStr = timeParts[1].trim().split(':')[0];
      const startTime = Number(startTimeStr);
      const endTime = Number(endTimeStr);

      result.push({
        day: dayNumber,
        start_time: isNaN(startTime) ? null : startTime,
        end_time: isNaN(endTime) ? null : endTime,
        max_time: null,
        status: 'work'
      });
    });
  });

  return result;
};

export function processSchedule(
  schedule: Array<{
    days: string;
    hours: string;
  }>
): Array<{
  days: string;
  hours: string;
}> {
  const dayOrder = {
    Пн: 0,
    Вт: 1,
    Ср: 2,
    Чт: 3,
    Пт: 4,
    Сб: 5,
    Вс: 6
  };

  const sorted = schedule
    .slice()
    .sort((a, b) => dayOrder[a.days] - dayOrder[b.days]);

  const result: Array<{
    days: string;
    hours: string;
  }> = [];
  if (sorted.length === 0) return result;

  let currentStart = sorted[0].days;
  let currentEnd = sorted[0].days;
  let currentHours = sorted[0].hours;

  for (let i = 1; i < sorted.length; i++) {
    const dayObj = sorted[i];
    if (dayObj.hours === currentHours) {
      currentEnd = dayObj.days;
    } else {
      const newEl = {
        days:
          currentStart === currentEnd
            ? currentStart
            : `${currentStart}-${currentEnd}`,
        hours: currentHours
      };
      result.push(newEl);
      currentStart = dayObj.days;
      currentEnd = dayObj.days;
      currentHours = dayObj.hours;
    }
  }
  const newEl = {
    days:
      currentStart === currentEnd
        ? currentStart
        : `${currentStart}-${currentEnd}`,
    hours: currentHours
  };
  result.push(newEl);

  return result;
}
